import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Title for the suppliers card in product suppliers tab',
    defaultMessage: 'Suppliers',
    id: 'Q28xNX',
  },
  subtitle: {
    description: 'Subtitle for the suppliers card in product suppliers tab',
    defaultMessage: 'Suppliers assigned to this product, along with the unit of measure, supplier SKU and cost.',
    id: 'lMmSQ3',
  },
  assignSupplierButton: {
    description: 'Button label to assign a supplier to a product in product suppliers tab',
    defaultMessage: 'Assign Supplier',
    id: 'sc2OFu',
  },
  columnSupplierName: {
    description: 'Column header for supplier name in product suppliers tab',
    defaultMessage: 'Supplier',
    id: 'G9gBTM',
  },
  columnUomSku: {
    description: 'Column header for unit of measure SKU in product suppliers tab',
    defaultMessage: 'UoM SKU',
    id: 'tWxb7p',
  },
  columnSupplierSku: {
    description: 'Column header for supplier SKU in product suppliers tab',
    defaultMessage: 'Supplier SKU',
    id: '3h0tZO',
  },
  columnCost: {
    description: 'Column header for cost in product suppliers tab',
    defaultMessage: 'Cost',
    id: 'NwXXHd',
  },
  emptyState: {
    description: 'Empty state message in product suppliers tab when no suppliers are assigned',
    defaultMessage: 'No suppliers are assigned to this product.',
    id: 'E+4+Jo',
  },
  loadingError: {
    description: 'Error message in product suppliers tab when suppliers fail to load',
    defaultMessage: 'Failed to load suppliers.',
    id: 'GzjA5H',
  },
});
